import { FulcrumProvider } from 'bzx-common/../fulcrum/src/services/FulcrumProvider'
import chainConfigs from 'bzx-common/src/config/chains'
import PositionEventsGroup from 'bzx-common/src/domain/fulcrum/PositionEventsGroup'
import assetUtils from 'bzx-common/src/lib/assetUtils'
import * as mobx from 'mobx'
import RootStore from '../RootStore'
import TradeStore from './TradeStore'

export interface IHistoryTokenProps {
  eventsGroup: PositionEventsGroup
}

export default class HistoryToken implements IHistoryTokenProps {
  eventsGroup: PositionEventsGroup
  fulcrumProvider: FulcrumProvider
  rootStore: RootStore
  tradeStore: TradeStore

  get blockExplorerUrl() {
    return chainConfigs[this.fulcrumProvider.currentChainId].chainDetails.blockExplorer
  }

  get latestEvent() {
    return this.eventsGroup.events[this.eventsGroup.events.length - 1]
  }

  get otherEvents() {
    return this.eventsGroup.events.slice(0, -1).reverse()
  }

  get payTradingFeeTokenInfo() {
    return this.latestEvent && this.latestEvent.payTradingFeeEvent
      ? assetUtils.getCommon(this.latestEvent.payTradingFeeEvent.token)
      : undefined
  }

  /**
   * Helper to set values through mobx actions.
   */
  set(prop: keyof IHistoryTokenProps, value: any) {
    ;(this[prop] as any) = value
  }

  /**
   * Helper to assign multiple props values through a mobx action.
   */
  assign(props: { [key: string]: any }) {
    Object.assign(this, props)
  }

  constructor(rootStore: RootStore, eventsGroup: PositionEventsGroup) {
    this.rootStore = rootStore
    this.tradeStore = rootStore.tradeStore
    this.fulcrumProvider = rootStore.fulcrumProvider
    this.eventsGroup = eventsGroup
    mobx.makeAutoObservable(this, undefined, { deep: false, autoBind: true })
  }
}
